import script from "./TheDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./TheDrawer.vue?vue&type=style&index=0&id=6a8a0e88&lang=sass"

const __exports__ = script;

export default __exports__